import {
  createContext,
  LoaderFunctionArgs,
  MiddlewareFunction,
  redirect,
  useRouteLoaderData,
} from "react-router";
import { Application, Link } from "../api/api";
import { getJSON } from "../api/digipost-fetch";
import { cached } from "../api/cache";
import { EntrypointLoadError } from "../errors/errors";
import { rootPath } from "../translation/useRootPath";

type Rolle = "VIRKSOMHET";
export interface Entrypoint {
  rolle?: Rolle;
  midpUrl: string | null;
  applications: Array<Application>;
  _links: Array<Link>;
}

export const ROOT_ROUTE_ID = "root";

export const fetchEntrypoint = () =>
  cached("entrypoint", () =>
    getJSON<Entrypoint>("/api").catch((error) =>
      Promise.reject(new EntrypointLoadError(error)),
    ),
  );

export const entrypointContext = createContext<Entrypoint>();

export const entrypointMiddleware: MiddlewareFunction = async (
  { context },
  next,
) => {
  context.set(entrypointContext, await fetchEntrypoint());

  await next();
};

export const entrypointLoader = ({ context }: LoaderFunctionArgs): Entrypoint =>
  context.get(entrypointContext);

export const requireLoginMiddleware: MiddlewareFunction = async (
  { params, context },
  next,
) => {
  if (!context.get(entrypointContext).rolle) {
    throw redirect(`${rootPath(params.language)}/login`);
  }

  await next();
};

export const useEntrypointContext = (): Entrypoint => {
  const entrypoint = useRouteLoaderData<Entrypoint>(ROOT_ROUTE_ID);

  if (!entrypoint) {
    throw new Error("context ikke satt");
  }

  return entrypoint;
};

export const useApplications = (): Array<Application> =>
  useEntrypointContext().applications;

export const useMidpUrl = (): string | null => useEntrypointContext().midpUrl;
